module.exports = __webpack_public_path__ + "img/recommended.60a49f49.svg";